module.exports = __webpack_public_path__ + "img/leader-black.c6cf4bc9.svg";